
import React, { useState } from "react";
import {
    IconButton,
    Badge,
    Menu,
    MenuItem,
    Typography,
    Box,
    Avatar,
    Divider,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Popover,
    Stack,
    Button
} from "@mui/material";
import {
    Notifications as NotificationsIcon,
    Circle as CircleIcon,
    CheckCircle as CheckCircleIcon
} from "@mui/icons-material";
import { useNotification } from "../context/NotificationContext";

const NotificationMenu = () => {
    const { notifications, unreadCount, markAsRead, clearAll } = useNotification();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMarkAsRead = (id) => {
        markAsRead(id);
        // Optionally keep menu open or close it
    };

    const open = Boolean(anchorEl);
    const id = open ? "notification-popover" : undefined;

    return (
        <>
            <IconButton
                size="large"
                aria-describedby={id}
                onClick={handleOpen}
                color="inherit"
            >
                <Badge badgeContent={unreadCount} color="error">
                    <NotificationsIcon />
                </Badge>
            </IconButton>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                PaperProps={{
                    sx: {
                        width: 360,
                        maxHeight: 480,
                        overflow: "hidden", // Let inner list scroll
                        display: "flex",
                        flexDirection: "column",
                    },
                }}
            >
                <Box
                    sx={{
                        p: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #eee",
                    }}
                >
                    <Typography variant="h6">Notifications</Typography>
                    {unreadCount > 0 && (
                        <Button size="small" onClick={clearAll}>
                            Mark all read
                        </Button>
                    )}
                </Box>

                <List sx={{ overflowY: "auto", flexGrow: 1, p: 0 }}>
                    {notifications.length === 0 ? (
                        <ListItem>
                            <ListItemText
                                primary={
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        align="center"
                                        sx={{ py: 3 }}
                                    >
                                        No new notifications
                                    </Typography>
                                }
                            />
                        </ListItem>
                    ) : (
                        notifications.map((notification) => (
                            <React.Fragment key={notification.id}>
                                <ListItem
                                    alignItems="flex-start"
                                    button
                                    onClick={() => !notification.is_read && handleMarkAsRead(notification.id)}
                                    sx={{
                                        bgcolor: notification.is_read ? "transparent" : "action.hover",
                                    }}
                                >
                                    <ListItemAvatar>
                                        <Avatar sx={{ bgcolor: notification.is_read ? "grey.300" : "primary.main" }}>
                                            <NotificationsIcon />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={notification.title || "Notification"} // Fallback title
                                        secondary={
                                            <React.Fragment>
                                                <Typography
                                                    component="span"
                                                    variant="body2"
                                                    color="text.primary"
                                                    sx={{ display: "block", mb: 0.5 }}
                                                >
                                                    {notification.message}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    {new Date(notification.created_at).toLocaleString()}
                                                </Typography>
                                            </React.Fragment>
                                        }
                                    />
                                    {!notification.is_read && (
                                        <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                                            <CircleIcon color="primary" sx={{ fontSize: 12 }} />
                                        </Box>
                                    )}
                                </ListItem>
                                <Divider component="li" />
                            </React.Fragment>
                        ))
                    )}
                </List>
            </Popover>
        </>
    );
};

export default NotificationMenu;
